import {Injectable} from "@angular/core";
import {Message, MessageService} from "primeng/api";

@Injectable()
export class ToastMessageService {

  private readonly key = 'message';
  private readonly appErrorStatusKey = 'app-error-status-message';
  private readonly appAutoUpdateInfoStatusKey = 'app-auto-update-info-status-message';

  constructor(private messageService: MessageService) {
    // empty
  }

  clearAppErrorStatusMessage(): void {
    this.messageService.clear(this.appErrorStatusKey);
  }

  showAppErrorStatusMessage(summary: string): void {
    this.messageService.add({
      key: this.appErrorStatusKey,
      summary: summary,
      sticky: true,
      closable: false,
    });
  }

  clearAppAutoUpdateInfoStatusMessage(): void {
    this.messageService.clear(this.appAutoUpdateInfoStatusKey);
  }

  showAppAutoUpdateInfoStatusMessage(summary: string): void {
    this.messageService.add({
      key: this.appAutoUpdateInfoStatusKey,
      summary: summary,
      sticky: true,
      closable: false,
    });
  }

  show(message: Message) {
    message.key = this.key;
    this.messageService.add(message);
  }

  showMessage(summary: string, detail?: string) {
    this.messageService.add({
      key: this.key,
      summary: summary,
      detail: detail,
      severity: 'info',
    });
  }

  showSuccess(summary: string, detail?: string) {
    this.messageService.add({
      key: this.key,
      summary: summary,
      detail: detail,
      severity: 'success',
    });
  }

  showError(summary: string, detail?: string) {
    this.messageService.add({
      key: this.key,
      summary: summary,
      detail: detail,
      severity: 'error',
      life: 5000
    });
  }

  showWarning(summary: string, detail?: string) {
    this.messageService.add({
      key: this.key,
      summary: summary,
      detail: detail,
      severity: 'warn',
    });
  }
}
